var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("common.entity_account.entity_account_details_file"),
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start mb-5" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.listItemsEntityAccountFile.length > 0
                ? [
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("common.entity_account.details"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .DateStartImport !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.date_start_import"
                                            ),
                                            inputValue: _vm.getDate(
                                              _vm.listItemsEntityAccountFile[0]
                                                .DateStartImport
                                            ),
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.date_start_import"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "common.entity_account.processing_time"
                                        ),
                                        inputValue: _vm.processingDuration,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-col", {
                                  staticClass: "mb-5",
                                  attrs: { sm: "4" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .FileName !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_name"
                                            ),
                                            inputValue:
                                              _vm.listItemsEntityAccountFile[0]
                                                .FileName,
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_name"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .FileReference !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_reference"
                                            ),
                                            inputValue:
                                              _vm.listItemsEntityAccountFile[0]
                                                .FileReference,
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_reference"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0].Bic !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.bic"
                                            ),
                                            inputValue:
                                              _vm.listItemsEntityAccountFile[0]
                                                .Bic,
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.bic"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0].Status !==
                                    ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_status"
                                            ),
                                            inputValue: _vm.$t(
                                              "common.entity_account.file_status_" +
                                                _vm
                                                  .listItemsEntityAccountFile[0]
                                                  .Status
                                            ),
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_status"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .SynchroType !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.synchro_type"
                                            ),
                                            inputValue: _vm.$t(
                                              "common.entity_account.synchro_type_" +
                                                _vm
                                                  .listItemsEntityAccountFile[0]
                                                  .SynchroType
                                            ),
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.synchro_type"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .ImportResult !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.import_result"
                                            ),
                                            inputValue: _vm.$t(
                                              "common.entity_account.import_result_" +
                                                _vm
                                                  .listItemsEntityAccountFile[0]
                                                  .ImportResult
                                            ),
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.import_result"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr", { staticClass: "mx-auto" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t(
                                "common.entity_account.file_history"
                              ),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.listItemsEntityAccountFileHistory.length > 0
                              ? _c(
                                  "table",
                                  {
                                    staticClass: "table table-striped w-50",
                                    staticStyle: { margin: "0 auto" },
                                  },
                                  [
                                    _c(
                                      "tbody",
                                      [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { staticClass: "text-center w-25" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.entity_account.date_action"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { staticClass: "text-center w-25" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.entity_account.file_status"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.listItemsEntityAccountFileHistory,
                                          function (his) {
                                            return _c(
                                              "tr",
                                              {
                                                key: _vm
                                                  .listItemsEntityAccountFileHistory
                                                  .IdEntityAccountFile,
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-center w-25",
                                                  },
                                                  [
                                                    his.DateAction !== ""
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getDate(
                                                                his.DateAction
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-center w-25",
                                                  },
                                                  [
                                                    his.Status !== ""
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.entity_account.file_status_" +
                                                                  his.Status
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }